/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TInspectorNode } from "../InspectorNodeTypes";
import { offEvent, onEvent } from "@adapptio/lib-shared";

export function subscribeToNodeChange(node: TInspectorNode, handler: () => void): () => void {
	const uniqueDeps = node?.deps?.length > 0 ? Array.from(new Set(node.deps)) : [];
	const unsubs: Array<() => void> = [];
	const subscribedIds = new Set();

	for (let i = 0; i < uniqueDeps.length; i++) {
		const depModel = uniqueDeps[i];

		if (depModel) {
			if (subscribedIds.has(depModel.nodeId)) {
				continue;
			}

			subscribedIds.add(depModel.nodeId);

			onEvent(depModel.changeEvent, handler);

			unsubs.push(() => offEvent(depModel.changeEvent, handler));
		}
	}

	return () => {
		for (let i = 0; i < unsubs.length; i++) {
			unsubs[i]();
		}
	};
}
